import React, { useRef, useEffect } from 'react';
import SignaturePad from 'react-signature-canvas';
import './SignatureDrawing.css';
import TauriImage from '../../../../TauriImage/TauriImage';

const SignatureDrawing = ({ onSignatureChange, Signature }) => {
    const sigPadRef = useRef();

    const handleEnd = () => {
        if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
            const dataUrl = sigPadRef.current.toDataURL('image/png');  // Directly use toDataURL
            
            fetch(dataUrl)
            .then(res => res.blob())
            .then(blob => {
                onSignatureChange(blob);
            });
        }
    };

    const clearSignature = () => {
        if (sigPadRef.current) {
            sigPadRef.current.clear();
            onSignatureChange(null);
        }
    };

    useEffect(() => {
        const canvas = sigPadRef.current?.getCanvas();
        if (canvas) {
            const ratio = window.devicePixelRatio || 1;
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext('2d').scale(ratio, ratio);
        }

        if (Signature && sigPadRef.current) {
            if (typeof Signature === 'string') {
                // If it's still a base64 URL, load normally
                sigPadRef.current.fromDataURL(Signature);
            } else if (Signature instanceof Blob) {
                // If it's a Blob, convert it to DataURL first
                const reader = new FileReader();
                reader.onload = () => {
                    sigPadRef.current.fromDataURL(reader.result);
                };
                reader.readAsDataURL(Signature);
            }
        } else {
            sigPadRef.current?.clear();
        }
    }, [Signature]);

    useEffect(() => {
        const canvas = sigPadRef.current?.getCanvas();
    
        if (canvas) {
            const ratio = window.devicePixelRatio || 1;
    
            // Resize canvas to match display size * devicePixelRatio
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);
    
            sigPadRef.current.clear();
        }
    }, []);
    

    return (
        <div className="signature-pad">
            <SignaturePad
                ref={sigPadRef}
                canvasProps={{ className: 'signature-canvas' }}
                onEnd={handleEnd}
            />
            <TauriImage className={"btn-clear"} localImage={"/Images/clear.svg"} color={"#389EE7"} onClick={clearSignature} />
        </div>
    );
};

export default SignatureDrawing;
